import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { AppConfig } from './app.config';

@Injectable({
  providedIn: 'root'
})
export class CartService {

  constructor(public http: HttpClient, public AppConfig: AppConfig) { }


  addPaymentLead(reqData:any) {
    // const httpOptions = {
    //   headers: new HttpHeaders({
    //     'Content-Type': 'application/json'
    //   })
    // };

    // return this.http.post( 'https://api-in21.leadsquared.com/v2/ProspectActivity.svc/Create?accessKey=u$rc72385611f1224759b26f7dc0b0b2b1b&secretKey=6db9186234fe0d7e2de0755e06ce8d6b4c446696',reqData,  httpOptions)
    //   .pipe(map((response: any) => response));
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    return this.http.post('https://api-in21.leadsquared.com/v2/SalesActivity.svc/Create?accessKey=u$rf3b5048d49f0ce03e5d3dd47b3aa47ea&secretKey=be9a1825cf08d42fa8544e33de1ca67b7d75fc2d', reqData, httpOptions)
      .pipe(map((response: any) => response));
  }

  applyReferralCode(token:any, reqData:any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Token ' + token
      })
    };

    return this.http.get(this.AppConfig.API_ENDPOINT + 'RefferalCodeCheck?referral_code=' + reqData.code + '&course_id=' + reqData.id, httpOptions)
      .pipe(map((response: any) => response));
  }

  applyProductReferralCode(token:any, reqData:any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Token ' + token
      })
    };

    return this.http.get(this.AppConfig.API_ENDPOINT + 'ProductRefferalCodeCheck?referral_code=' + reqData.code + '&product_id=' + reqData.id, httpOptions)
      .pipe(map((response: any) => response));
  }

  applyCoupon(token:any, reqData:any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Token ' + token
      })
    };

    return this.http.get(this.AppConfig.API_ENDPOINT1 + 'coupon_get?code=' + reqData.code + '&course_id=' + reqData.id, httpOptions)
      .pipe(map((response: any) => response));
  }

applyProductCoupon(token:any, reqData:any) {
  const httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      // 'Authorization': 'Token ' + token
    })
  };

  return this.http.get(this.AppConfig.API_ENDPOINT + 'product_coupon_get?coupon_code=' + reqData.code + '&product_id=' + reqData.id, httpOptions)
    .pipe(map((response: any) => response));
}

  ApplyQuizCoupon(token:any, reqData:any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Token ' + token
      })
    };

    return this.http.get(this.AppConfig.API_ENDPOINT + 'quiz_coupon_get?code=' + reqData.code + '&quizpack_id=' + reqData.id, httpOptions)
      .pipe(map((response: any) => response));
  }

  payment(token:any, reqData:any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Token ' + token
      })
    };

    // return this.http.post(this.AppConfig.API_ENDPOINT1 + 'payment_start_test', reqData, httpOptions)
    return this.http.post(this.AppConfig.API_ENDPOINT1 + 'payment_start_test_with_easybuzz', reqData, httpOptions)
      .pipe(map((response: any) => response));
  }

  Quizpayment(token:any, reqData:any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Token ' + token
      })
    };
    return this.http.post(this.AppConfig.API_ENDPOINT + 'quiz_start_test_with_easebuzz', reqData, httpOptions)
    // return this.http.post(this.AppConfig.API_ENDPOINT + 'quiz_payment_start_test', reqData, httpOptions)
      .pipe(map((response: any) => response));
  }

  paymentSuccess(token:any, reqData:any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Token ' + token
      })
    };

    // return this.http.post(this.AppConfig.API_ENDPOINT1 + 'store_payment_details', reqData, httpOptions)
    return this.http.post(this.AppConfig.API_ENDPOINT1 + 'store_payment_details_with_easybuzz', reqData, httpOptions)
      .pipe(map((response: any) => response));
  }

  productPaymentSuccess(token:any, reqData:any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Token ' + token
      })
    };

    // return this.http.post(this.AppConfig.API_ENDPOINT1 + 'store_payment_details_product', reqData, httpOptions)
    return this.http.post(this.AppConfig.API_ENDPOINT1 + 'store_payment_details_product_with_easebuzz', reqData, httpOptions)
      .pipe(map((response: any) => response));
  }

  QuizPaymentSuccess(token:any, reqData:any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Token ' + token
      })
    };

    // return this.http.post(this.AppConfig.API_ENDPOINT + 'store_payment_quiz_details', reqData, httpOptions)
    return this.http.post(this.AppConfig.API_ENDPOINT + 'store_payment_quiz_details_with_easebuzz', reqData, httpOptions)
      .pipe(map((response: any) => response));
  }

  saveDiscount(token:any, reqData:any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Token ' + token
      })
    };

    return this.http.post(this.AppConfig.API_ENDPOINT1 + 'final_cost/', reqData, httpOptions)
      .pipe(map((response: any) => response));
  }

  saveProductDiscount(token:any, reqData:any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Token ' + token
      })
    };

    return this.http.post(this.AppConfig.API_ENDPOINT1 + 'Coupon_users', reqData, httpOptions)
      .pipe(map((response: any) => response));
  }

  getbatches(id:any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };

    return this.http.get(this.AppConfig.API_ENDPOINT + 'batches?course_id=' + id, httpOptions)

      .pipe(map((response: any) => response));
  }


  getCourseCoupons(id:any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };

    return this.http.get(this.AppConfig.API_ENDPOINT + 'coupons_by_course/' + id, httpOptions)

      .pipe(map((response: any) => response));
  }

  getProductCoupons(id:any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };

    return this.http.get(this.AppConfig.API_ENDPOINT + 'GetCouponBasedonProduct?product_id=' + id, httpOptions)
      .pipe(map((response: any) => response));
  }

  getOnlyProductCoupons(id:any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };

    return this.http.get(this.AppConfig.API_ENDPOINT + 'GetCouponBasedonSingleProduct?product_id=' + id, httpOptions)
      .pipe(map((response: any) => response));
  }


  getQuizCoupons(id:any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };

    return this.http.get(this.AppConfig.API_ENDPOINT + 'quizcoupons_by_quizpackage/' + id, httpOptions)

      .pipe(map((response: any) => response));
  }

  payCuet(token:any, reqData:any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Token ' + token
      })
    };

    return this.http.post(this.AppConfig.API_ENDPOINT + 'partialcourse_create', reqData, httpOptions)
      .pipe(map((response: any) => response));
  }

  cuetupdate(token:any, reqData:any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Token ' + token
      })
    };

    return this.http.put(this.AppConfig.API_ENDPOINT + 'partialcourse_update', reqData, httpOptions)
      .pipe(map((response: any) => response));
  }

  productCheckout(token:any, reqData:any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Token ' + token
      })
    };

    // return this.http.post(this.AppConfig.API_ENDPOINT1 + 'payment_start_product', reqData, httpOptions)
    return this.http.post(this.AppConfig.API_ENDPOINT1 + 'payment_start_product_with_easebuzz', reqData, httpOptions)
      .pipe(map((response: any) => response));
  }

  getCustomCourseCoupons(id:any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };

    return this.http.get(this.AppConfig.API_ENDPOINT + 'GetCouponsBasedoncustomcourse?custom_course_id='+id, httpOptions)
      .pipe(map((response: any) => response));
  }

  applyCustomCourseCoupon(reqData:any, token:any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Token ' + token
      })
    };

    return this.http.get(this.AppConfig.API_ENDPOINT + 'custom_coupon_get?coupon_code='+ reqData.code +'&custom_course_id='+reqData.id, httpOptions)
      .pipe(map((response: any) => response));
  }

  applyCustomCourseReferral(token:any, reqData:any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Token ' + token
      })
    };

    return this.http.get(this.AppConfig.API_ENDPOINT + 'CustomCourseRefferalCodeCheck?referral_code='+ reqData.code +'&custom_course_id='+reqData.id, httpOptions)
      .pipe(map((response: any) => response));
  }

  purchaseCustomCourse(reqData:any, token:any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Token ' + token
      })
    };

    // return this.http.post(this.AppConfig.API_ENDPOINT1 + 'payment_start_custom_course', reqData, httpOptions)
    return this.http.post(this.AppConfig.API_ENDPOINT1 + 'payment_start_custom_course_with_easebuzz', reqData, httpOptions)
      .pipe(map((response: any) => response));
  }

  saveCustomCourseDetails(token:any, reqData:any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Token ' + token
      })
    };

    // return this.http.post(this.AppConfig.API_ENDPOINT1 + 'store_payment_details_custom_course', reqData, httpOptions)
    return this.http.post(this.AppConfig.API_ENDPOINT1 + 'store_payment_details_custom_course_with_easebuzz', reqData, httpOptions)
      .pipe(map((response: any) => response));
  }

  paymock(token:any, reqData:any, id:any) {
    // const httpOptions = {
    //   headers: new HttpHeaders({
    //     'Content-Type': 'application/json',
    //       'token': 'f61a6f71-2bc4-4b50-8fe0-e2694671207f',
    //       'secret': '7796b364-02d2-42db-990b-bc1973b68211'
    //   })
    // };

    // return this.http.post('https://dev.iqmock.iquanta.in/business/purchase/'+id, reqData, httpOptions)
    //   .pipe(map((response: any) => response));
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Token ' + token
      })
    };

    return this.http.post(this.AppConfig.LOGIN_ENDPOINT + 'MocksCourseGPost', reqData, httpOptions)
      .pipe(map((response: any) => response));
  }

  catScoreCalculator(type:any,catScoreurl:any){

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };

    return this.http.post('https://api.iverse.iquanta.in/api/student/connect/calculateMarks/'+type, catScoreurl, httpOptions)
      .pipe(map((response: any) => response));

  }

  iimIndoreScoreCalculator(type:any,catScoreurl:any){

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };

    return this.http.post('https://api.iverse.iquanta.in/api/student/connect/ipmat/ipmatCalculateMarks/'+type, catScoreurl, httpOptions)
      .pipe(map((response: any) => response));

  }

  iitScoreCalculator(reqObj:any){

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };

    return this.http.post('https://itech-api-prod.iquanta.in/api/iit-result/v1/result/student', reqObj, httpOptions)
      .pipe(map((response: any) => response));

  }

  getUserCatScoreData(type:any){

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };

    return this.http.get('https://itech-api-prod.iquanta.in/api/scoreVsPer/v1/test/all/'+type, httpOptions)
      .pipe(map((response: any) => response));

  }

  getUserIIMScoreData(type:any){

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };

    return this.http.get('https://itech-api-prod.iquanta.in/api/ipmat-result/v1/result/student/'+type, httpOptions)
      .pipe(map((response: any) => response));

  }

  getUserXatScoreData(type:any){

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };

    return this.http.get('https://itech-api-prod.iquanta.in/api/xat-result/v1/result/student/'+type, httpOptions)
      .pipe(map((response: any) => response));

  }

  getXatAnalysisdata(type:any){

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };

    return this.http.get('https://itech-api-prod.iquanta.in/api/xat-result/v1/result/student/analysis/'+type, httpOptions)
      .pipe(map((response: any) => response));

  }


  getBschoolsEligible(type:any){

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };

    return this.http.post('https://itech-api-prod.iquanta.in/api/scoreVsPer/v1/readBschool/all/', type, httpOptions)
      .pipe(map((response: any) => response));

  }

  xatScoreCalculator(type:any,catScoreurl:any){

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };

    // return this.http.post('https://api.iverse.iquanta.in/api/student/connect/xat/xatCalculateMarks/'+type, catScoreurl, httpOptions)
    //   .pipe(map((response: any) => response));

      return this.http.post('https://api.iverse.iquanta.in/api/student/connect/xat/xatCalculateMarks/final/'+type, catScoreurl, httpOptions)
      .pipe(map((response: any) => response));

  }

  catToppersList(token:any, reqData:any){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Token ' + token
      })
    };

    return this.http.post(this.AppConfig.LOGIN_ENDPOINT + 'XatToppersList', reqData, httpOptions)
      .pipe(map((response: any) => response));
  }

  xatToppersList(token:any, reqData:any){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Token ' + token
      })
    };

    return this.http.post(this.AppConfig.LOGIN_ENDPOINT + 'XatToppersList', reqData, httpOptions)
      .pipe(map((response: any) => response));
  }

  getCatToppersList(selectCount:any, pageCount:any, reqData:any){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
    
      })
    };

    return this.http.post('https://api.iverse.iquanta.in/api/student/connect/getLeaderBoard?page='+pageCount+'&limit='+selectCount, reqData,  httpOptions)
    .pipe(map((response: any) => response));

    // return this.http.get(this.AppConfig.LOGIN_ENDPOINT + 'AllCatToppersList?page_count='+pageCount+'&select_count='+selectCount, httpOptions)
    //   .pipe(map((response: any) => response));
  }

  getIIMIndoreToppersList(selectCount:any, pageCount:any, reqData:any){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
    
      })
    };

    return this.http.get('https://itech-api-prod.iquanta.in/api/ipmat-result/v1/result/student/leaderboard/0?page='+pageCount+'&limit='+selectCount, httpOptions)
    .pipe(map((response: any) => response));

    // return this.http.get(this.AppConfig.LOGIN_ENDPOINT + 'AllCatToppersList?page_count='+pageCount+'&select_count='+selectCount, httpOptions)
    //   .pipe(map((response: any) => response));
  }


  getIitToppersList(selectCount:any, pageCount:any, reqData:any){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
    
      })
    };

    return this.http.post('https://api.iverse.iquanta.in/api/student/connect/iit/getLeaderBoard?page='+pageCount+'&limit='+selectCount,{},  httpOptions)
    .pipe(map((response: any) => response));
    // return this.http.get('https://itech-api-prod.iquanta.in/api/iit-result/v1/result/student/leaderboard/0?page='+pageCount+'&limit='+selectCount,  httpOptions)
    // .pipe(map((response: any) => response));

    // return this.http.get(this.AppConfig.LOGIN_ENDPOINT + 'AllCatToppersList?page_count='+pageCount+'&select_count='+selectCount, httpOptions)
    //   .pipe(map((response: any) => response));
  }

  getSuggestions(reqData:any){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
    
      })
    };

    return this.http.post('https://itech-api-prod.iquanta.in/api/sop-review/v1/postScorePercentile/post', reqData,  httpOptions)
    .pipe(map((response: any) => response));
  }

  getBSchools(){
      return this.http.get('https://media.iquanta.in/bschoolslist.json').pipe(map((response: any) => response));
  }

  getEmojis(){
    return this.http.get('https://media.iquanta.in/list.with.modifiers.json').pipe(map((response: any) => response));
}

  getXatBSchools(){
    return this.http.get('https://media.iquanta.in/ui_images/XAT-BSchool.json');
}

  getCollegeWiseData(){
    return this.http.get('https://media.iquanta.in/media/collegeRankWise.json').pipe(map((response: any) => response));
}

  getXatToppersList(selectCount:any, pageCount:any){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
    
      })
    };

    return this.http.get('https://itech-api-prod.iquanta.in/api/xat-result/v1/result/student/leaderboard/0?page='+pageCount+'&limit='+selectCount, httpOptions)
    .pipe(map((response: any) => response));

    // return this.http.get(this.AppConfig.LOGIN_ENDPOINT + 'AllXatToppersList?page_count='+pageCount+'&select_count='+selectCount, httpOptions)
    //   .pipe(map((response: any) => response));
  }

  userCatScoreData(token:any){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Token ' + token
      })
    };

    return this.http.get(this.AppConfig.LOGIN_ENDPOINT + 'UserScoreCatData', httpOptions)
      .pipe(map((response: any) => response));
  }

}
